import { Injectable } from '@angular/core';
import { ApiService } from '@core/providers/http/api.service';
import { Observable } from 'rxjs';
import { HttpHeaders, HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '@environments/environment';

@Injectable({ providedIn: 'root' })
export class ProfissionalService {
  private readonly path = 'profissionais';
  private apiVagas = `${environment.apiProfissionaisUrl.replace(/\/+$/, '')}/profissionais`;

  constructor(private apiService: ApiService, private http: HttpClient) {}

  list(params?: any): Observable<any> {
    return this.apiService.get(
      `${this.path}/getAllProfissional`,
      this.getParams(params),
      true
    );
  }

  show(id: string): Observable<any> {
    return this.apiService.get(
      `${this.path}/getProfissionalById/${id}`,
      this.getParams(),
      true
    );
  }

  showByUserId(userId: string): Observable<any> {
    return this.apiService.get(
      `${this.path}/getProfissionalByUserId/${userId}`,
      this.getParams(),
      true
    );
  }

  add(data: any): Observable<any> {
    return this.apiService.post(`${this.path}/AddProfissional`, data, {}, true);
  }

  update(data: any): Observable<any> {
    return this.apiService.put(
      `${this.path}/UpdateProfissional`,
      data,
      this.getParams(),
      true
    );
  }

  delete(id: string): Observable<any> {
    return this.apiService.delete(
      `${this.path}/DeleteProfissionalById/${id}`,
      this.getParams(),
      true
    );
  }

  getPhoto(id: string): Observable<any> {
    return this.apiService.get(
      `${this.path}/getPhotoProfissional/${id}`,
      this.getParams(),
      true
    );
  }

  /** GET /profissionais/GerarComprovativo?VagaId=... (espera query params) */
  gerarComprovativo(params: {
    VagaId: number | string;
    [k: string]: any;
  }): Observable<Blob> {
    const headers = new HttpHeaders().set('Accept', 'application/pdf');

    return this.http.get(`${this.apiVagas}/GerarComprovativo`, {
      headers,
      params: this.getParams(params),
      responseType: 'blob',
    });
  }

  /**
   * POST /profissionais/api/KeyKloakController/usuarios/validar?email=...
   * (sem body, só query param `email`)
   */
  validar(email: string): Observable<any> {
    const base = `${this.path}/api/KeyKloakController/usuarios/validar`;
    const query = this.getParams({ email }).toString(); // encoda o email
    return this.apiService.post(`${base}?${query}`, {}, {}, true);
  }

  private getParams(params?: any): HttpParams {
    return params ? new HttpParams({ fromObject: params }) : new HttpParams();
  }
}
